import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import GanttProps from './GanttProps'
import KendoGanttColumn from '../KendoGanttColumn'
import KendoGanttView from '../KendoGanttView'
import KendoGanttToolbar from '../KendoGanttToolbar'
import Assignments from './Assignments'
import CurrentTimeMarker from './CurrentTimeMarker'
import Editable from './Editable'
import Messages from './Messages'
import Pdf from './Pdf'
import Range from './Range'
import Resources from './Resources'
import Tooltip from './Tooltip'

export default {
    props: GanttProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Assignments,
        CurrentTimeMarker,
        Editable,
        Messages,
        Pdf,
        Range,
        Resources,
        Tooltip
    ],
    mounted() {
        this._resolveChildren()
        this.setInnerDataSource('dependenciesDataSourceRef', 'dependencies')
        kendo.jQuery(this.$el).kendoGantt(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoGantt()
        },
        _resolveChildren() {
            this.resolveChildren('columns', KendoGanttColumn.name)
            this.resolveChildren('views', KendoGanttView.name)
            this.resolveChildren('toolbar', KendoGanttToolbar.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/KendoGanttMixin.js